import Dsr from "../Pages/Dsr";

export const Url = {

  SIGNINWITH_EMAIL: 'admin/admin_signin',
  GENERATE_EMAILOTP:'admin/GenerateEmailOTP',
  VERIFY_EMAILOTP:'admin/VerifyEmailOTP',
  POSTREWARDS: 'admin/reward_policy',
  PGM_LIST: 'admin/GetAllPgmUsers',
  REWARD: 'admin/reward_policy',
  REWARD_REDEEM: 'admin/ProductCodeMapping',
  REWARD_REDEEM_DETAIL:'admin/DetailProductCodeMapping',
  POST_REWARD: 'admin/reward_policy',
  POST_REWARD_REDEEM:'admin/ProductCodeMapping',
  POST_EDIT_REWARD_REDEEM:'admin/EditProductCodeMapping',
  PGM_DETAIL: 'admin/AccountDetails',
  CREATE_TRAINEE: 'admin/CreateTraining',
  GET_TRAINEE: 'admin/GetAllTrainings',
  CREATE_TRAINEE_INVITE: 'admin/SendInviteAndUpdate',
  GET_TRAINEE_ATTENDEE: 'admin/GetAllTrainings',
  PUT_ADMIN_VERIFICATION: 'admin/AdminVerification',
  GET_QUERY: 'admin/QueryList',
  GET_QUERY_DETAIL: 'admin/SupportQueryDetailsListApi',
  POST_FAQ: 'admin/createFaq',
  GET_FAQ: 'admin/getFaqList',
  TRAINING_FILTER: 'admin/FilterPgmTrainings',
  POST_QUERY_SOLUTION: 'admin/EditSupportApi',
  POST_EDIT_FAQ: 'admin/editFaq',
  FAQ_DETAIL: 'admin/getFaqDetails',
  CATEGORY_LIST:'admin/CategoryListApi',
  CREATE_FAQ:'admin/createFaq',
  CREATE_ANNOUNCE:'admin/createFaq',
  GET_TRAINEE_DETAIL:'admin/GetTrainingDetail',
  GET_USER_TRAINING:'admin/GetUserTrainingApi',
  PUT_TRAINING_UPDATE:'admin/EditTrainingApi',
  UPDATE_PGM_STATUS:'admin/MarkAttendance',
  DELETE_FAQ_IMG:'admin/deleteFaqAttachment',
  LOGOUT:'admin/admin_SignOut',
  SEND_INVITE:'admin/SendInviteToInterested',
  CREATE_TRAINER:'admin/CreateInstructorApi',
  TRAINER_LIST:'admin/GetAllInstructorsDetail',
  TRAINER_DETAIL:'admin/GetInstructorApi',
  UPDATE_TRAINER:"admin/UpdateInstructorApi",
  NOTIFICATION_LIST:'admin/ListScheduledNotiifcation',
  NOTIFICATION_DETAIL:'admin/ListScheduledNotiifcation',
  UPDATE_NOTIFICATION:'admin/EditSheduleNotifications',
  CREATE_NOTIFICATION:'admin/Shedulenotifications',
  CREATE_NOTIFICATION_EXCEL:'admin/ExcelNotification',
  STATE_LIST:'admin/GetStatesList',
  DISTRICT_LIST:'admin/GetDistrictsList',
  DELETE_SKILL:'admin/TrainerSkillDeleteView',
  GET_PINCODE:'admin/PincodeDetails',
  CHANGE_PASSWORD:'admin/ChangePassword',
  FORGET_PASSWORD:'admin/ForgotPassword',
  VERIFY_FORGOT_PASSWORD_OTP:'admin/VerifyEmailOTP',
  RESET_PASSWORD:'admin/ResetPassword',
  PGM_LIST_EXCEL:'admin/DownloadPgmList',
  PGM_LIST_3W_EXCEL:'admin/DownloadPgm3WList',
  USER_GROUPS:'admin/UserGroups',
  NOTIFICATION_LIST_EXCEL:'admin/DownloadScheduledNotification',
  MSR_LIST_EXCEL:'admin/DownloadMsrList',
  SUPPORT_QUERY_EXCEL:'admin/DownloadSupportQuery',
  SUPPORT_QUERY_3W_EXCEL:'admin/support/v2/SupportQuery/Download',
  REDEMPTION_LIST:'admin/RedemptionLimit',
  SCAN_LIST:'admin/CouponScanPolicy',
  REFFRAL_POILICY:'admin/ReferralPolicy',
  POST_REDEMPTION:'admin/RedemptionLimit',
  POST_SCANLIMIT:'admin/CouponScanPolicy',
  POST_REFFERAL:'admin/ReferralPolicy',
  REPORTS:'admin/Reports/',
  REPORT_MASTER:'admin/ReportMaster',
  ROLE_NAMES:'admin/Role',
  REPORT_NAMES:'admin/Role',
  PERMISSION:'admin/Permission',
  ROLE_NAMES_LIST:'admin/Role',
  REDEMPTION_LIST_EXCEL:'admin/DownloadRedemptionLimit',
  REDIRECTION_PAGE:'admin/GetRedirectionPageList',
  RETRIVE_ALL_BANNER_IMAGE:'admin/BannerImages',
  CREATE_BANNER:'admin/BannerImage',
  UPDATE_BANNER:'admin/BannerImage',
  ACTIVE_BANNER:'admin/UpdateBannerImageActiveStatus',
  ACTIVE_MSR:'admin/MsrToggleStatus',
  DELETE_BANNER:'admin/DeleteBannerImage',
  BANNER_IMAGE_DETAIL:'admin/BannerImageDetail',
  REDIRECTION_PAGE:'admin/RedirectionPages',
  UPDATE_BANNER_IMAGE_SEQUENCE:'admin/UpdateBannerImageSequence',
  CREATE_ROLE:'admin/Role',
  PGM_APPROVAL:'admin/PgmApproval',
  CREATE_USER:'admin/AdminUser',
  CREATE_MSR:'admin/MsrUser',
  CREATE_TRUCHAMPS:'admin/ValidateReferralCode',
  UPDATE_USER:'admin/AdminUser',
  UPDATE_MSR:'admin/MsrUser',
  USER_NAMES:'admin/AdminUserProfileDetail',
  MSR_NAMES:'admin/MsrUser',
  USER_NAMES_LIST:'admin/RetrieveAdminUserProfile',
  MSR_NAMES_LIST:'admin/MsrUsers',
  USER_VERIFICATION:'admin/AdminUserVerification',
  PGM_DETAIL_EDIT:'admin/EditUser',
  // Training Module
  
  VEHICLE_TUTORIAL_LIST:'training/v2/pgm/GetTutorialList',
  VEHICLE_CATEGORY_LIST:'training/v2/pgm/GetVehicleCategoryList',
  CREATE_CONTENT:'training/v2/pgm/CreateTutorial',
  UPDATE_CONTENT:'training/v2/pgm/UpdateTutorial',
  TRAINING_TUTORIAL_DETAILS : "training/v2/pgm/Tutorial",
  VEHICLE_CATEGORY_LIST:'training/v2/pgm/GetVehicleCategoryList',
  VEHICLE_MODULE_LIST:'training/v2/pgm/GetVehicleModuleList',
  TOGGLE_USER_STATUS:'admin/ToggleUserStatus',
  MODULE_LIST:'training/v2/pgm/TrainingModulesList',
  EDIT_MODULE:'training/v2/pgm/UpdateModule/{id}',
  UPDATE_TUTORIAL:'training/v2/pgm/UpdateTutorial/{training_tutorial_id}',
  MODULE_BY_ID : 'training/v2/pgm/GetModuleDetails/{id}',
  ADD_MODULE:'training/v2/pgm/CreateModule',
  ADD_QUERY_COMMENT:'admin/AddQueryComment',

  // support query
  GET_QUERY3W:'admin/support/v2/QueryListView',
  GET_QUERY_CATEGORY:'admin/CategoryListApi',
  GET_ASSIGNEE_LIST:'admin/AdminSupportUser',
  ASSIGN_QUERY:'admin/AssignQuery',
  VIEW_SUPPORT_QUERY:'admin/support/SupportQueryDetails',
  TOGGLE_USER_STATUS:'admin/ToggleUserStatus',
  MODULE_LIST:'training/v2/pgm/TrainingModulesList',
  EDIT_MODULE:'training/v2/pgm/UpdateModule/{id}',
  UPDATE_TUTORIAL:'training/v2/pgm/UpdateTutorial/{training_tutorial_id}',
  MODULE_BY_ID : 'training/v2/pgm/GetModuleDetails/{id}',
  ADD_MODULE:'training/v2/pgm/CreateModule',
  VEHICLE_TUTORIAL_LIST_SELECTED:'training/v2/pgm/GetSelectedUnselectedTutorialList/',

    //Referral section
    GET_REFERRAL_LIST:'admin/LeadReferral/List',
    // Generate Unique Id
    CREATE_UNIQUE_ID:'admin/UniqueID/Generate',
    COLOR_CODE:'admin/UniqueID/CapColourCodes',
    PART_CATEGORY:'admin/UniqueID/PartCategories',

  GET_UNIQUE_ID_GENERATION: 'admin/UniqueID/GenerationRequestList',
  CREATE_DSR:'admin/DSR/Create',
  DSR_NAMES_LIST:'admin/DSR/List',
  DSR_PINCODE:'admin/PincodeDetails',
  ACTIVE_DSR:'admin/DSR/Deactivate',
  UPDATE_DSR:'admin/DSR/Edit',
  DETAILS_DSR:'admin/DSR/Detail',
  DSR_NAMES:'admin/DsrUser',
  DSR_LIST_EXCEL:'admin/DSR/DownloadExcel',
  CREATE_BeatMap:'admin/BeatPlan/Create',
  BeatMap_LOGS:'admin/BeatPlan/Logs',
  BeatMap_EXCEL:'admin/BeatPlan/Download',
  BeatMap_Details:'admin/BeatPlan/Logs/Details',

  // DBT Rules Management
  DBT_RULES_LIST:'admin/DbtRule',
  DBT_RULE_DETAIL:'admin/DbtRule',
  DBT_RULE_CREATE:'admin/Dbt',
  DBT_RULE_UPDATE:'admin/DbtRule',
  DBT_RULE_DELETE:'admin/DbtRule/Delete',
  DBT_RULES_EXCEL:'admin/DbtRule/Download',
  ACTIVE_DBT:'admin/reward/DBT/UpdateDbtStatus',

  // DBT Configuration (Settings)
  DBT_CONFIGURATION: 'admin/DBTConfigView',

  // Pincode Master List
  PINCODE_MASTER_LIST:'admin/PincodeMasterList',
  PINCODE_MASTER_DOWNLOAD:'admin/PincodeMasterExcel',
  PINCODE_MASTER_CREATE:'admin/UploadPincodeMaster',
  PINCODE_MASTER_LOGS:'admin/PincodeMasterFileList',
  PINCODE_MASTER_LOGS_DETAILS:'admin/PincodeMasterFileException',
  PINCODE_MASTER_ERROR_DOWNLOAD:'admin/PincodeMasterFileDownload',

  // Plan vs Actual
  TARGET_ACHIEVEMENT_LIST:'admin/ApsPlanVsActual',
  TARGET_ACHIEVEMENT_DOWNLOAD:'admin/ApsPlanVsActual',

  // Plan vs Actual - APS Drill-down
  APS_LIST: 'admin/ApsUserList',
  APS_CUSTOMERS: 'admin/GetAPSCustomers',
  CUSTOMER_TARGET_DETAIL: 'admin/CustomerTargetDetailFileDownload',

  // Plan vs Actual - Customer Detail Page
  CUSTOMER_DETAIL_LIST: 'admin/ApsMonthCustomerPlanVSActual',
  CUSTOMER_DETAIL_DOWNLOAD: 'admin/ApsMonthCustomerPlanVSActual',

  // Plan vs Actual - Single Customer Detail
  SINGLE_CUSTOMER_DETAIL: 'admin/CustomerPlanVSActual',

  // Cluster Management
  CLUSTER_LIST:'admin/Cluster',
  CLUSTER_PART_LIST:'admin/ClusterPart',

  // Region Search
  REGION_SEARCH:'admin/RegionSearch',

  // USER TYPE LIST
  USER_TYPE:'admin/UserTypeMaster',

  // DBT Invoice Scan Status
  DBT_INVOICE_SCAN_STATUS:'admin/DbtInvoiceScanStatus',
  DBT_INVOICE_SCAN_STATUS_EXCEL:'admin/DbtInvoiceScanStatus/Download',

  // 2W Training Module
  VEHICLE_TUTORIAL_LIST_2W:'training/v2/pgm/GetTutorialList',
  CREATE_CONTENT_2W:'training/v2/pgm/CreateTutorial',
  UPDATE_CONTENT_2W:'training/v2/pgm/UpdateTutorial',
  TRAINING_TUTORIAL_DETAILS_2W:'training/v2/pgm/Tutorial',
  VEHICLE_CATEGORY_LIST_2W:'training/v2/pgm/GetVehicleCategoryList',
  VEHICLE_MODULE_LIST_2W:'training/v2/pgm/GetVehicleModuleList',
  MODULE_LIST_2W:'training/v2/pgm/TrainingModulesList',
  EDIT_MODULE_2W:'training/v2/pgm/UpdateModule/{id}',
  MODULE_BY_ID_2W:'training/v2/pgm/GetModuleDetails/{id}',
  ADD_MODULE_2W:'training/v2/pgm/CreateModule',
  VEHICLE_TUTORIAL_LIST_SELECTED_2W:'training/v2/pgm/GetSelectedUnselectedTutorialList/',
  DELETE_CONTENT_2W:'training/v2/pgm/DeleteTutorial',
  DELETE_MODULE_2W:'training/v2/pgm/DeleteModule',
  TRAINING_CATEGORY:'admin/TrainingCategory',
  TYPE_MASTER_LIST:'training/v2/pgm/TypeMaster/List',
}

